import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import {
  hasChartRecordData,
  normalizeChartRecord,
} from "../../../utils/chartData";

const PieChartEmpty = () => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, padding: "12px 0 20px" }}>
    <div style={{ position: "relative", width: 160, height: 160 }}>
      <div
        style={{
          width: 160,
          height: 160,
          borderRadius: "50%",
          background: "conic-gradient(#e5e7eb 0deg 140deg, #d1d5db 140deg 252deg, #efefef 252deg 360deg)",
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: 68,
            height: 68,
            borderRadius: "50%",
            background: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ fontSize: 11, color: "#9ca3af", textAlign: "center", lineHeight: 1.3 }}>No data<br />yet</span>
        </div>
      </div>
    </div>
    <div style={{ display: "flex", gap: 16 }}>
      {[{ color: "#e5e7eb", w: 60 }, { color: "#d1d5db", w: 52 }, { color: "#efefef", w: 68 }].map((item, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <div style={{ width: 10, height: 10, borderRadius: 2, background: item.color, border: "1px solid #e0e0e0", flexShrink: 0 }} />
          <div style={{ width: item.w, height: 10, background: item.color, borderRadius: 3, border: "1px solid #e0e0e0" }} />
        </div>
      ))}
    </div>
  </div>
);

const PieChart = ({
  data,
}: {
  data: Record<string, string | number> | [] | null;
}) => {
  const normalized = normalizeChartRecord(data);
  const labels = normalized ? Object.keys(normalized) : [];
  const series = normalized
    ? Object.values(normalized).map((v) => parseFloat(v))
    : [];

  const isEmpty = !hasChartRecordData(data);

  const options: ApexOptions = {
    chart: { type: "pie" },
    labels,
    legend: { position: "bottom", fontSize: "14px" },
    responsive: [{ breakpoint: 480, options: { legend: { position: "bottom" } } }],
  };

  if (isEmpty) return <PieChartEmpty />;

  return (
    <div style={{ maxWidth: 300, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Chart options={options} series={series} type="pie" />
    </div>
  );
};

export default PieChart;
